/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus =
  {
    WorkflowStatusUnspecified: "WORKFLOW_STATUS_UNSPECIFIED",
    WorkflowStatusDraft: "WORKFLOW_STATUS_DRAFT",
    WorkflowStatusActive: "WORKFLOW_STATUS_ACTIVE",
    WorkflowStatusPaused: "WORKFLOW_STATUS_PAUSED",
    WorkflowStatusFailed: "WORKFLOW_STATUS_FAILED",
    WorkflowStatusCompleted: "WORKFLOW_STATUS_COMPLETED",
    WorkflowStatusArchived: "WORKFLOW_STATUS_ARCHIVED",
    WorkflowStatusPendingApproval: "WORKFLOW_STATUS_PENDING_APPROVAL",
    WorkflowStatusValidating: "WORKFLOW_STATUS_VALIDATING",
    WorkflowStatusQuotaExceeded: "WORKFLOW_STATUS_QUOTA_EXCEEDED",
    WorkflowStatusWarning: "WORKFLOW_STATUS_WARNING",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat =
  {
    OutputFormatUnspecified: "OUTPUT_FORMAT_UNSPECIFIED",
    OutputFormatJson: "OUTPUT_FORMAT_JSON",
    OutputFormatCsv: "OUTPUT_FORMAT_CSV",
    OutputFormatBigquery: "OUTPUT_FORMAT_BIGQUERY",
    OutputFormatPostgres: "OUTPUT_FORMAT_POSTGRES",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: Date | undefined;
    lastRunTime?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus
      | undefined;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    jobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat
      | undefined;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody =
  {
    workflow?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow
      | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest =
  {
    workspaceId: string;
    requestBody:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus =
  {
    WorkflowStatusUnspecified: "WORKFLOW_STATUS_UNSPECIFIED",
    WorkflowStatusDraft: "WORKFLOW_STATUS_DRAFT",
    WorkflowStatusActive: "WORKFLOW_STATUS_ACTIVE",
    WorkflowStatusPaused: "WORKFLOW_STATUS_PAUSED",
    WorkflowStatusFailed: "WORKFLOW_STATUS_FAILED",
    WorkflowStatusCompleted: "WORKFLOW_STATUS_COMPLETED",
    WorkflowStatusArchived: "WORKFLOW_STATUS_ARCHIVED",
    WorkflowStatusPendingApproval: "WORKFLOW_STATUS_PENDING_APPROVAL",
    WorkflowStatusValidating: "WORKFLOW_STATUS_VALIDATING",
    WorkflowStatusQuotaExceeded: "WORKFLOW_STATUS_QUOTA_EXCEEDED",
    WorkflowStatusWarning: "WORKFLOW_STATUS_WARNING",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat =
  {
    OutputFormatUnspecified: "OUTPUT_FORMAT_UNSPECIFIED",
    OutputFormatJson: "OUTPUT_FORMAT_JSON",
    OutputFormatCsv: "OUTPUT_FORMAT_CSV",
    OutputFormatBigquery: "OUTPUT_FORMAT_BIGQUERY",
    OutputFormatPostgres: "OUTPUT_FORMAT_POSTGRES",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: Date | undefined;
    lastRunTime?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus
      | undefined;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    jobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat
      | undefined;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

/**
 * Creates a new workflow for a specific workspace
 */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody =
  {
    workflow?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow
      | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeadsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$inboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$inboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$inboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: string | undefined;
    lastRunTime?: string | undefined;
    status: string;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    jobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$Outbound
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat: string;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.date().transform(v => v.toISOString()).optional(),
    lastRunTime: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsStatus$outboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsJobs$outboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsOutputFormat$outboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflowToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflowFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    workflow: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$inboundSchema
    ).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$Outbound =
  {
    workflow?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$Outbound
      | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody
  > = z.object({
    workflow: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkflow$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBodyToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    workspaceId: z.string(),
    RequestBody: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$inboundSchema
    ),
  }).transform((v) => {
    return remap$(v, {
      "RequestBody": "requestBody",
    });
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$Outbound =
  {
    workspaceId: string;
    RequestBody:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$Outbound;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest
  > = z.object({
    workspaceId: z.string(),
    requestBody: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestBody$outboundSchema
    ),
  }).transform((v) => {
    return remap$(v, {
      requestBody: "RequestBody",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsRequest' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Day$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeadsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponse200Status$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$inboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$inboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$inboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: string | undefined;
    lastRunTime?: string | undefined;
    status: string;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    jobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$Outbound
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat: string;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.date().transform(v => v.toISOString()).optional(),
    lastRunTime: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesResponseStatus$outboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesJobs$outboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesOutputFormat$outboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflowToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflowFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    workflow: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$inboundSchema
    ).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$Outbound =
  {
    workflow?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$Outbound
      | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody
  > = z.object({
    workflow: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsWorkspacesWorkflow$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBodyToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsResponseBody' from JSON`,
  );
}
